<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Gestión de Profesores</v-toolbar-title>
      </v-toolbar>

      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Búsqueda de Profesores</h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="apellido"
                prepend-icon="mdi-account"
                label="Apellidos"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="nombre"
                prepend-icon="mdi-account"
                label="Nombres"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
      <v-card-actions class="mt-0 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          color="primary"
          @click.stop="buscarProfesores()"
        >
          Buscar
          <v-icon dark right>mdi-magnify</v-icon>
        </v-btn>
      </v-card-actions>

      <v-data-table
        v-if="listaProfesores.length"
        :headers="headers"
        :items="this.listaProfesores"
        class="elevation-1"
        locale="es-ar"
        item-key="idProfesor"
        :items-per-page="10"
        ref="myTable"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="purple"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="editarProfesor(item)"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Editar Profesor</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                v-on="on"
                color="red"
                v-bind="attrs"
                @click="borrarProfesor(item)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar Profesor</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-alert class="mt-4" color="purple" dark outlined v-else>
        No hay profesores configurados para el complejo.
      </v-alert>
      <v-card-actions>
        <v-btn dark color="#24232d" @click="salir">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="nuevoProfesor"
          >Nuevo Profesor</v-btn
        >
        <v-btn
          color="warning"
          :disabled="listaProfesores.length < 1"
          @click.stop="imprimir"
          >Imprimir</v-btn
        >
      </v-card-actions>
      <NuevoProfesor
        :visible="showNuevoProfesor"
        @close="cierraNuevoProfesor()"
        @profesorRegistrado="profesorRegistrado()"
      ></NuevoProfesor>
      <EditarProfesor
        :visible="showEditarProfesor"
        :idProfesor="editedItem.idProfesor"
        @close="cierraEditarProfesor()"
        @profesorModificado="profesorModificado()"
      ></EditarProfesor>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "@/axios-auth";
import router from "@/router";
import jsPDF from "jspdf";
import autotable from "jspdf-autotable";
import NuevoProfesor from "./NuevoProfesor.vue";
import EditarProfesor from "./EditarProfesor.vue";
import { showAlert } from "@/utils/toast";
export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    nombre: null,
    apellido: null,
    listaProfesores: [],
    headers: [
      { text: "Apellidos", value: "apellido" },
      { text: "Nombres", value: "nombre" },
      { text: "Celular", value: "celular" },
      { text: "Acciones", value: "actions" },
    ],
    showNuevoProfesor: false,
    showEditarProfesor: false,
    editedItem: {},
    editedIndex: -1,
  }),
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    borrarProfesor(item) {
      this.$swal({
        title: "Borrar profesor",
        text: "¿Desea borrar el profesor?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const idProfesor = item.idProfesor;
          let self = this;
          axios
            .get("/Profesional/BorrarProfesor?", {
              params: {
                idProfesor: idProfesor,
              },
            })
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title: "El profesor tiene transacciones asociadas.",
                  vm: self,
                  timer: 2000,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Profesor borrado exitosamente.",
                  vm: self,
                  timer: 2000,
                });
                setTimeout(self.buscarProfesores(), 1700);
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El profesor no pudo ser borrado.",
                vm: this,
                timer: 2000,
              });
            });
        } else {
        }
      });
    },
    cierraNuevoProfesor() {
      this.showNuevoProfesor = false;
    },
    cierraEditarProfesor() {
      this.showEditarProfesor = false;
    },
    profesorRegistrado() {
      this.showNuevoProfesor = false;
      this.buscarProfesores();
    },
    profesorModificado() {
      this.showEditarProfesor = false;
      this.buscarProfesores();
    },
    nuevoProfesor() {
      this.showNuevoProfesor = true;
    },
    editarProfesor(item) {
      this.editedIndex = this.listaProfesores.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarProfesor = true;
    },
    buscarProfesores() {
      const filtrosData = {
        apellido: this.apellido,
        nombre: this.nombre,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Profesional/GetProfesoresDeInst?", {
          params: {
            apellido: filtrosData.apellido,
            nombre: filtrosData.nombre,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaProfesores = response.data;
          else {
            self.listaProfesores = [];
          }
        })
        .catch(function (error) {});
    },
    imprimir() {
      var source = this.$refs["myTable"];
      let rows = [];
      let columnHeader = ["Apellidos", "Nombre"];
      source.items.forEach((element) => {
        var temp = [element.apellido, element.nombre];
        rows.push(temp);
      });
      var doc = new jsPDF();
      doc.setProperties({
        title: "Listado Profesores",
      });
      var nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      doc.setFontSize(12);
      doc.text(nombreInstitucion, 13, 10);
      doc.setFontSize(10);

      doc.setFontSize(16);
      doc.text(
        "Listado de Profesores",
        doc.internal.pageSize.getWidth() / 2,
        33,
        { align: "center" },
      );
      doc.autoTable(columnHeader, rows, {
        startY: 39,
        didParseCell: function (table) {
          if (table.section === "head") {
            table.cell.styles.fillColor = "#c4c5c5";
          }
        },
      });

      window.open(doc.output("bloburl"), "_blank");
    },
  },
  created() {
    this.buscarProfesores();
  },
  components: {
    NuevoProfesor,
    EditarProfesor,
  },
};
</script>
